import GradeIcon from "@mui/icons-material/LabelImportant";
import ViewListIcon from "@mui/icons-material/ViewList";
import LayersIcon from "@mui/icons-material/Layers";
import TuneIcon from "@mui/icons-material/Tune";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import PaletteIcon from "@mui/icons-material/Palette";
import ExtensionIcon from "@mui/icons-material/Extension";
import BuildIcon from "@mui/icons-material/Build";
import EventNoteIcon from "@mui/icons-material/EventNote";

export const settingsMenu = [
  {
    section: "Leads",
    key: "lead_grade",
    label: "Grade",
    icon: <GradeIcon />,
  },
  {
    section: "Leads",
    key: "lead_features",
    label: "Features",
    icon: <ViewListIcon />,
  },

  {
    section: "Pipelines",
    key: "pipeline_status",
    label: "Status",
    icon: <LayersIcon />,
  },
  {
    section: "Pipelines",
    key: "pipeline_features",
    label: "Features",
    icon: <TuneIcon />,
  },
  {
    section: "Pipelines",
    key: "booking_systems",
    label: "Bookings",
    icon: <EventNoteIcon />,
  },
  {
    section: "System",
    key: "services",
    label: "Services",
    icon: <BuildIcon />,
  },
  {
    section: "System",
    key: "theme",
    label: "Theme",
    icon: <PaletteIcon />,
  },

  {
    section: "System",
    key: "integrations",
    label: "Integrations",
    icon: <ExtensionIcon />,
  },
  {
    section: "System",
    key: "sla",
    label: "SLA",
    icon: <AccessTimeIcon />,
  },
];
